export const formatInputMoeda = (
  input = '',
  simbolo = 'R$ ',
  delimitadorCentesimal = '.',
  delimitadorDecimal = ','
) => {
  if (!input.length) return '';
  const isNegativo = input.replace(/[^-]/g, '').length === 1;
  input = input.replace(/\D/g, ''); //Retira tudo o q não é numero
  input = input.length <= 3 ? input : input.replace(/^0+/g, ''); //Retira os zeros se a length for <= 3
  input = input.length ? input : `0`;
  input = input.length && input.length === 2 ? `0${input}` : input; //Coloca um zero se o tamanho for 2
  input = input.length && input.length === 1 ? `00${input}` : input; //Coloca dois zeros se o tamanho for 1
  input = input.replace(/(\d{1})(\d{2})$/, `$1${delimitadorDecimal}$2`); // coloca virgula antes dos ultimos 2 digitos
  while (
    input !== input.replace(/(\d{1,})(\d{3})/g, `$1${delimitadorCentesimal}$2`)
  ) {
    input = input.replace(/(\d{1,})(\d{3})/g, `$1${delimitadorCentesimal}$2`);
  }
  input = `${simbolo}${
    isNegativo && input !== `0${delimitadorDecimal}00` ? '- ' : ''
  }${input}`;
  return input;
};

export const numberToMoeda = (
  num: number,
  simbolo = 'R$ ',
  delimitadorCentesimal = '.',
  delimitadorDecimal = ','
) => {
  if (isNaN(num)) return 'NaN';
  num = parseFloat(String(num));
  const negativo = num < 0;
  const numeroInteiro = parseInt(String(Math.abs(num)));
  const numeroAbsoluto = Math.abs(numeroInteiro);
  let numerosDecimais = (
    parseFloat((Math.abs(num) - numeroInteiro).toFixed(2)) * 100
  ).toFixed(0);
  if (parseInt(numerosDecimais) < 10) numerosDecimais = `0${numerosDecimais}`;
  return `${simbolo}${negativo ? '- ' : ''}${String(numeroAbsoluto).replace(
    /(\d)(?=(\d\d\d)+(?!\d))/g,
    `$1${delimitadorCentesimal}`
  )}${delimitadorDecimal}${numerosDecimais}`;
};

export const unformatMoeda = (input = '', maxLength?: number) => {
  input = String(input);
  if (!input || !input.length) return '';

  const isNegativo = input.replace(/[^-]/g, '').length === 1;
  input = input.replace(/\D/g, '');
  if (maxLength) {
    input = input.substring(0, maxLength);
  }
  if (input.length > 3) {
    input = input.replace(/^0+/g, '');
  }
  input = input.replace(/(\d+)(\d{2})$/, `$1.$2`);
  return parseFloat(`${isNegativo ? '-' : ''}${input}`);
};
